<template>
    <div 
        v-scrollable="!clone"
    >
        <table 
            class="table" 
            :class="{'absolute top-0 right-0 table-clone': clone}"
            :style="style"
            ref="table"
        >
            <thead>
                <tr>
                    <th 
                        v-for="column in columns"
                        :width="column.width" 
                    >{{ column.label }}</th>
                    <th 
                        v-if="actions.length && !loading" 
                        :width="clone ? 50 : 0"
                        class="visible"
                    ></th>
                </tr>
            </thead>
            <tbody>
                <template v-if="loading">
                    <tr v-for="n in 5">
                        <td v-for="n in columns.length"><div class='row-loading'></div></td>
                    </tr>
                </template>
                <template v-else>
                    <template v-if="Object.entries(items).length">
                        <tr v-for="(item, index) in items">
                            <template v-for="column in columns">
                                <td
                                    v-copy
                                    :data-clipboard-text="item[column.key]"
                                    :title="`${item[column.key]} (click to copy)`"
                                    v-if="column.copiable && !column.layout"
                                >{{ item[column.key] }}</td>         
                                <td v-else>
                                    <template v-if="column.layout">
                                        <span 
                                            v-if="column.layout.name == 'badge'"
                                            class="badge"
                                            :class="column.layout.values[item[column.key]].class"
                                        >{{ column.layout.values[item[column.key]].label }}</span>
                                        <component 
                                            v-if="column.layout.name == 'icon'"
                                            :is="column.layout.values[item[column.key]].icon"
                                            :class="column.layout.values[item[column.key]].class"
                                        />
                                    </template>
                                    <template v-else>{{ item[column.key] }}</template>
                                </td>
                            </template>
                            <td 
                                class="overflow-visible"
                                v-if="actions.length"
                                :class="{visible: clone}"           
                            >
                                <dropdown :class="{invisible: !clone, visible: clone}">
                                    <template slot="trigger">
                                        <more-horizontal-icon />
                                    </template>
                                    <template slot="items">
                                        <div
                                            class="dropdown-item flex items-center"
                                            v-for="action in actions"
                                            @click="action.handler(item)"
                                        >
                                            <component :is="action.icon" />
                                            <span class="ml-2">{{ action.label }}</span>
                                        </div>
                                    </template>
                                </dropdown>
                            </td>   
                        </tr>
                    </template>
                    <tr v-else>
                        <td colspan="5" class="text-center">No users found.</td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            items: {
                type: Array,
                default() {
                    return [];
                },
            },
            columns: {
                type: Array,
                required: true,
            },
            left: {
                type: Array,
                default() {
                    return [];
                }
            },
            right: {
                type: Array,
                default() {
                    return [];
                }
            },
            actions: {
                type: Array,
                default() {
                    return [];
                }
            },
            emptyMessage: {
                type: String,
                default: 'No items found.'
            },
            loading: {
                type: Boolean,
                default: false,
            },
            clone: {
                type: Boolean,
                default: false,
            },
            position: {
                type: String,
                default: null,
            },
            width: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                style: {}
            }
        },
        watch: {
            loading(loading) {
                if (!loading && this.position) {
                    this.repositionTable();
                }
            }
        },
        mounted() {
            if (this.position) {
                this.repositionTable();
            }
        },
        methods: {
            repositionTable() {
                const width = this.$refs.table.offsetWidth

                if (this.position == 'right') {
                    this.style = {
                        right: `${width - this.width}px`
                    }
                }
            }
        }
    }
</script>